/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Project_Data_Processing_StatusInputs */

const en_iframe_remote_project_data_processing_status = /** @type {(inputs: Iframe_Remote_Project_Data_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing project data...`)
};

const fr_iframe_remote_project_data_processing_status = /** @type {(inputs: Iframe_Remote_Project_Data_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement des donnees du projet...`)
};

const de_iframe_remote_project_data_processing_status = /** @type {(inputs: Iframe_Remote_Project_Data_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitung der Projektdaten...`)
};

const it_iframe_remote_project_data_processing_status = /** @type {(inputs: Iframe_Remote_Project_Data_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione dei dati del progetto...`)
};

const ru_iframe_remote_project_data_processing_status = /** @type {(inputs: Iframe_Remote_Project_Data_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка проектных данных...`)
};

const es_iframe_remote_project_data_processing_status = /** @type {(inputs: Iframe_Remote_Project_Data_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando datos del proyecto...`)
};

const zh_cn2_iframe_remote_project_data_processing_status = /** @type {(inputs: Iframe_Remote_Project_Data_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在处理项目数据……`)
};

const ja_iframe_remote_project_data_processing_status = /** @type {(inputs: Iframe_Remote_Project_Data_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト データを処理しています...`)
};

const hi_iframe_remote_project_data_processing_status = /** @type {(inputs: Iframe_Remote_Project_Data_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट डेटा संसाधित किया जा रहा है...`)
};

const pt_pt2_iframe_remote_project_data_processing_status = /** @type {(inputs: Iframe_Remote_Project_Data_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processando dados do projeto...`)
};

/**
* | output |
* | --- |
* | "Processing project data..." |
*
* @param {Iframe_Remote_Project_Data_Processing_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_project_data_processing_status = /** @type {((inputs?: Iframe_Remote_Project_Data_Processing_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Project_Data_Processing_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_project_data_processing_status(inputs)
	if (locale === "de") return de_iframe_remote_project_data_processing_status(inputs)
	if (locale === "it") return it_iframe_remote_project_data_processing_status(inputs)
	if (locale === "ru") return ru_iframe_remote_project_data_processing_status(inputs)
	if (locale === "es") return es_iframe_remote_project_data_processing_status(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_project_data_processing_status(inputs)
	if (locale === "ja") return ja_iframe_remote_project_data_processing_status(inputs)
	if (locale === "hi") return hi_iframe_remote_project_data_processing_status(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_project_data_processing_status(inputs)
	return en_iframe_remote_project_data_processing_status(inputs)
});